import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin-bottom: 0.5rem;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25rem;
  }
  
  .w1 {
    padding-right: 0.15em !important;
    width: 5rem;

    .top-header {
      display: flex;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      height: 2em !important;
      padding: 0.5em 0em 0.5em 0em !important;
    }
  }

  .icon-button {
    cursor: pointer;
    margin: 0 0.1rem;
  }
`;

export const CardAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-top: 0.7rem;
  overflow: auto;
  min-height: 20rem;

  .colcsa {
    height: 2.5rem;
    display: flex;
    align-items: center;
    
    .titulo {
      font-size: 0.75rem;
      font-weight: 700;
      margin-left: 0.5rem;
    }
  }

  .href-item-anexo {
    background-color: ${Colors.Color1};
    color: ${Colors.Color7} !important;
    font-size: 0.79rem;
    line-height: 1rem;
    width: 100%;
    max-width: 100%;
    height: 2.5rem;
    border: 0;
    border-radius: 0rem;
    padding: 0em 1rem;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    
    i {
      color: ${Colors.Color7} !important;
      font-size: 1.3em;
    }
  }
  
  .w1 {
    padding-right: 0.15em !important;
    width: 5em !important;
  }

  .w2 {
    padding-right: 0.15em !important;
    width: 10rem;
  }

  .w3 {
    padding-right: 0.15em !important;
    width: 15rem;
  }

  .w4 {
    padding-right: 0.15em !important;
    width: 20rem;
  }

  .w5 {
    padding-right: 0.15em !important;
    width: 25em;
  }

  .w6 {
    padding-right: 0.15em !important;
    width: 30em;
  }

  .card-atv-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.5rem;

    .top-header{
      display: flex;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        align-items: center;

        .fundo-icon {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 1.40375rem;
          height: 1.40375rem;
          background: ${Colors.Color8};
          border-radius: 0.4375rem;

          .atividade {
            width: 0.95rem;
          }
        }

        .item {
          font-size: 0.75rem;
          color: ${Colors.Color4};
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }
    }

    .titulos-tab {
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25rem;
      background: ${Colors.Color23};
      color: ${Colors.Color9};
      border-radius: 0.5rem;

      span {
        color: #FFF;
      }
      
      .titulo {
        font-size: 0.75rem;
        font-weight: 700;
        margin-left: 0.5rem;
        color: #FFF;
      }
    }

    .icon-button {
      border: none;
      cursor: pointer;
      background: ${Colors.Color1};
      color: ${Colors.Color7};
      font-size: 1.125rem;
    }
  }

  .basic-select {
    width: 100%;

    .select__control {
      min-height: 2.53rem !important;
      line-height: 0.73em;
      margin-top: 0em !important;
      border-radius: 0px !important;
    }
  }

  .basic-multi-select {
    width: 100%;
  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: -0.3rem;

    .row-top {
      margin-top: 0em !important;
      display: flex;
      flex-direction: row;
    }
  
    .top-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      height: 2rem;
    }

    .padding-left {
      padding: 0;
      padding-left: 0.7em !important;
    }

    .row {
      width: auto;
      margin-left: 0 !important;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0rem;
        border-radius: 0;
        height: 2.5rem;
      }

      TextArea:focus {
        height: 9.5em !important;
      }

      .list-analista {
        display: flex;
        flex-direction: column;

        .item-analista {
          margin-top: 0.5rem;

          .icon-button {
            border: none;
            cursor: pointer;
            background: ${Colors.Color1};
            color: ${Colors.Color7};
            font-size: 1.125rem;
            margin-right: 0.3rem;
          }

          .padding-right {
            padding-right: 1em !important;
          }

          .col {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: 0rem;

            p {
              font-size: 0.75rem;
              color: ${Colors.Color7};
              font-weight: 500;
              margin-left: 0.5rem;
              width: 11rem;
            }
          }
        }
      }
    }
  }
`;